import type { IMediaItemSchema, IMediaSchema } from '../interface';

function newSchema(): IMediaSchema {
    return {
        version: 1,
        revision: 0,
        modifiedDate: new Date(),
        creationDate: new Date(),
        media: [],
    };
}

function _isIMediaSchema(object: unknown): object is IMediaSchema {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }
    const record: Partial<IMediaSchema> = object as Partial<IMediaSchema>;

    return (
        !isNullOrUndefined(record.version) &&
        !isNullOrUndefined(record.revision) &&
        !isNullOrUndefined(record.modifiedDate) &&
        !isNullOrUndefined(record.creationDate)
    );
}

function _isIMediaItemSchema(object: unknown): object is IMediaItemSchema {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }
    const record: Partial<IMediaItemSchema> = object as Partial<IMediaItemSchema>;

    return (
        !isNullOrUndefined(record.fileName) &&
        !isNullOrUndefined(record.sourceGuid) &&
        !isNullOrUndefined(record.sourceHash) &&
        !isNullOrUndefined(record.versions)
    );
}

function _expandMedium(object: Partial<IMediaItemSchema>): Record<string, unknown> {
    return {
        ...object,
        versions: (object.versions ?? []).map(version => ({
            ...version,
            creationDate: new Date((version.creationDate as unknown as string) || '2020-01-01'),
        })),
    };
}

function expandSchema(text: string): IMediaSchema | null {
    const preExpand = JSON.parse(text) as Partial<IMediaSchema> | undefined;

    const media = (preExpand?.media ?? [])
        .map(medium => _expandMedium(medium))
        .filter(medium => _isIMediaItemSchema(medium));

    const object: Partial<IMediaSchema> = {
        ...preExpand,
        revision: Number(preExpand?.revision ?? 0),
        /* We've just checked type above, #typescript-bug */
        media: media as unknown as IMediaItemSchema[],
    };

    return _isIMediaSchema(object) ? object : null;
}

function flattenSchema(schema: IMediaSchema): string {
    return JSON.stringify(schema);
}

export default Object.freeze({
    create: newSchema,
    expand: expandSchema,
    flatten: flattenSchema,
});
